import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgPrint = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M6.906 4.688h8.933l1.223 1.193v2.744h1.688V5.881c0-.448-.178-.877-.494-1.194l-1.194-1.193A1.69 1.69 0 0 0 15.872 3H6.906c-.9 0-1.656.755-1.656 1.687v3.938h1.688zM18.469 9.75H5.53A2.534 2.534 0 0 0 3 12.281v3.938c0 .466.378.843.844.843h1.969v2.813c0 .621.503 1.125 1.125 1.125h10.125c.62 0 1.125-.504 1.125-1.125v-2.812h1.968a.844.844 0 0 0 .844-.844V12.28a2.534 2.534 0 0 0-2.531-2.531M16.5 19.313h-9v-3.375h9zm2.813-3.938h-1.125c0-.621-.504-1.125-1.125-1.125H6.938c-.622 0-1.125.504-1.125 1.125H4.688v-3.094c0-.465.378-.844.843-.844H18.47c.465 0 .843.38.843.844z"
    }));
export default SvgPrint;
